import React from 'react';

interface ImportRowCellsProps {
  data: Record<string, unknown> | null | undefined;
}

/**
 * Filled cells of a rejected row, keyed by column letter. The server finds columns by header,
 * so the cells that matter are not always A–D.
 */
const ImportRowCells: React.FC<ImportRowCellsProps> = ({ data }) => {
  const cells = Object.entries(data ?? {}).filter(([, value]) => value !== null && value !== undefined && String(value).trim() !== '');

  if (cells.length === 0) return null;

  return (
    <div className="text-xs text-gray-600 mt-2">
      <p className="font-medium mb-1">Dữ liệu gốc:</p>
      <div className="grid grid-cols-2 gap-2">
        {cells.map(([column, value]) => (
          <div key={column}><span className="font-medium">{column}:</span> {String(value)}</div>
        ))}
      </div>
    </div>
  );
};

export default ImportRowCells;
